import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedRouteForm = (props) => {
    const initialFormData = {
        route: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);

    useEffect(() => {
        const val = props.routevalue || props.medroutevalue;
        if (val && (val.route_id || val.id)) {
            const { route, is_active, route_id, id } = val;
            setFormData({
                route: route || "",
                isactive: is_active == 1 || is_active === '1' || is_active === true,
                id: route_id || id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.routevalue, props.medroutevalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsMedRouteUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/drugs/add-drug-route` : `${process.env.REACT_APP_SERVER_URL}/drugs/update-drug-route`;
        let pelmedsMedRouteData = isAddMode ? 
            { "route": formData.route, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
            { "route": formData.route, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        const { data } = await axios.post(pelmedsMedRouteUrl, pelmedsMedRouteData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success(isAddMode ? "MedRoute added successfully" : "MedRoute updated successfully");
        }
        else {
            toast.info("Error while adding/updating MedRoute");
        }

        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        if (props.onCallParent) {
            props.onCallParent();
        }
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Route Name</Form.Label>
                        <Form.Control
                            placeholder='Route Name'
                            value={formData.route}
                            name="route"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            size="sm"
                            className="mt-4 w-50"
                            disabled={!formData.route}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            id='isactive'
                            name="isactive"
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};

MedRouteForm.propTypes = {
    routevalue: PropTypes.any,
    medroutevalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default MedRouteForm;
